import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import * as Highcharts from 'highcharts';
import {BarLineSerie, BarSerie, DonutSerie, LineSerie, PieSerie} from "./models/series.model";

@Component({
  selector: 'app-dashboard-chart',
  templateUrl: './dashboard-chart.component.html',
  styleUrls: ['./dashboard-chart.component.scss']
})
export class DashboardChartComponent implements OnInit, OnChanges {

  @Input() chartType: 'vbar-chart' | 'pie-chart' | 'hbar-chart' | 'topColumnBar' | 'threeBar-chart' | 'barChart' | 'singleBarChart' | 'barChartPercent' | 'barLineChart' | 'hbarChartPercent' | 'donut-chart'
  @Input() heading: string
  @Input() title: string
  @Input() hasSubTitle: boolean = false
  @Input() subTitle: string
  @Input() categories: string[] // CHARTS: vbar-chart, pie-chart, hbar-chart,barChartPercent
  @Input() barSeries: BarSerie[] // CHARTS: hbar-chart,barChart,singleBarChart,barChartPercent,
  @Input() barlineSeries: BarLineSerie[] // CHARTS: barLineChart
  @Input() lineSeries: LineSerie[] // CHARTS: line-chart, topColumnBar, threeBar-chart
  @Input() pieSeries: PieSerie[] // CHARTS: pie-chart
  @Input() donutSeries: DonutSerie[] // CHARTS: donut-chart
  @Input() tooltipMessage: string
  @Input() colors: string[] = ['rgb(0, 128, 12)', '#A9CCE3', '#F9E79F',]
  @Input() barChartOptions: object
  @Input() yTitle: string

  @Output() chartItem = new EventEmitter<{ name: string, value: string | number }>()

  optionsConfig: object

  Highcharts = Highcharts;
  chartOptions: object

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.ngOnInit()
  }
  ngOnInit(): void {


    this.optionsConfig = {
      'vbar-chart':
        {
          chart: {
            type: 'column'
          },
          title: {
            text: this.title
          },
          subtitle: {
            text: this.subTitle
          },
          xAxis: {
            categories: this.categories,
            crosshair: true
          },
          yAxis: {
            min: 0,
            title: this.yTitle
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0
            }
          },
          series: this.barSeries
        },
      'lineBar-chart': {
        chart: {
          chart: {
            type: 'column'
          },
        },
        title: {
          text: this.title
        },

        xAxis: {
          categories: this.categories,
        },
        yAxis: {
          title: {
            text: 'Number of Projects'
          }
        },

        tooltip: {
          split: true,
          valueSuffix: this.tooltipMessage
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: true,
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: false,
            }
          }
        },
        series: this.lineSeries,
      },
      'pie-chart': {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: {
          text: this.title
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: true,
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.percentage:.1f} %'
            }
          }
        },
        series: this.pieSeries,
        colors: this.colors
      },
      'donut-chart': {
        chart: {
          type: 'pie'
        },
        title: {
          text: this.title
        },
        tooltip: {
          headerFormat: '',
          format: '<b>{point.name}</b>: {point.percentage:.1f} %'
        },
        series: this.donutSeries
      },
      'hbar-chart': {
        chart: {
          type: 'bar'
        },
        title: {
          text: `${this.title}`
        },
        xAxis: {
          categories: this.categories
        },
        yAxis: {
          title: {
            enabled: false
          }
        },
        tooltip: {
          split: true,
          valueSuffix: this.tooltipMessage
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: true,
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: this.barSeries,
        colors: this.colors
      },
      'threeBar-chart': {
        chart: {
          type: 'column'
        },
        title: {
          text: this.title
        },
        xAxis: {
          categories: this.categories,
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: this.title
          }
        },
        tooltip: {
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: this.lineSeries
      },
      'topColumnBar': {
        chart: {
          type: 'column'
        },
        title: {
          text: `${this.title}`
        },
        xAxis: {
          categories: this.categories
        },
        crosshair: true,
        yAxis: {
          min: 0,
          title: {
            text: 'Amount'
          },
          stackLabels: {
            enabled: true,
            style: {
              color: (
                Highcharts.defaultOptions.title.style &&
                Highcharts.defaultOptions.title.style.color
              ) || 'gray',
              textOutline: 'none'
            }
          }
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: true,
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            },
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: this.lineSeries
      },
      'barChart': {
        chart: {
          type: 'bar'
        },
        title: {
          align: 'center',
          text: this.title,
        },
        xAxis: {
          categories: this.categories
        },
        yAxis: {
          title: {
            text: 'Total percent plan Completion'
          }

        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: '{point.y:.1f}%'
            }
          }
        },

        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        },
        credits: {
          enabled: false
        },
        series: this.barSeries,
      },
      'barChartPercent': {
        chart: {
          type: 'column'
        },
        title: {
          align: 'center',
          text: this.title,
        },
        xAxis: {
          categories: this.categories,
          crosshair: true
        },
        yAxis: {
          title: {
            text: 'Rate'
          }

        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: '{point.y:.1f}%'
            }
          }
        },

        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        },
        credits: {
          enabled: false
        },
        series: this.barSeries,
      },
      'hbarChartPercent': {
        chart: {
          type: 'bar'
        },
        title: {
          align: 'center',
          text: this.title,
        },
        xAxis: {
          categories: this.categories,
          crosshair: true
        },
        yAxis: {
          title: {
            text: 'Rate'
          }

        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: '{point.y:.1f}%'
            }
          }
        },

        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        },
        credits: {
          enabled: false
        },
        series: this.barSeries,
      },
      'barLineChart': {
        chart: {
          type: 'column',

        },
        title: {
          align: 'center',
          text: this.title,
        },
        xAxis: {
          categories: this.categories,
          crosshair: true
        },
        yAxis: {
          title: {
            text: 'Rate'
          }

        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true
            }
          }
        },

        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        },
        credits: {
          enabled: false
        },
        series: this.barlineSeries,
      },

      'singleBarChart': {
        chart: {
          type: 'column'
        },
        title: {
          text: this.title
        },
        xAxis: {
          categories: this.categories
        },
        yAxis: {
          min: 0,
          title: {
            text: this.title
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: this.barSeries,
        colors: this.colors
      }
    }


    // Set subTitle if Applicable
    if (this.hasSubTitle) {
      this.optionsConfig[this.chartType].subtitle = {
        text: `${this.subTitle}`
      }
    }

    // For pie chart Slice first data
    if (this.chartType == 'pie-chart') {
      this.optionsConfig[this.chartType].series[0].sliced = true
      this.optionsConfig[this.chartType].series[0].selected = true
    }


    this.chartOptions = this.optionsConfig[this.chartType];

  }

  clickedItem(event: any) {

    alert(event)
    console.log(event)
  }

}
